import localforage from 'localforage'

const localforageInstance = localforage.createInstance({
  driver: localforage.INDEXEDDB,
  name: 'ritm3'
})

export default localforageInstance
